import React, { Component } from 'react';

//import cari css
import "../../css/CariAppForm.css";

//views
import CariMainPg from "./cari_layouts/external/CariMainPg";
import CariMainPgLoggedIn from "./cari_layouts/authenticated/CariMainPgLoggedIn";

//modals
import CariModals from "./cari_modal_view/CariModals";

//load generic functions
import {
    isEmpty
} from "../../../functions/generic_functions";

//regex email string
import {
    emailRegex
} from "../../../static_data/static_strings";

//router
import {
    Route,
    Switch,
    Redirect
} from 'react-router-dom';

//get static routes
import {
    cari_home_pg_url,
} from "../../../router/static_routes";

//redux
import { connect } from "react-redux";
import {
    setCariActiveVerifiedLoginUserData,
    setCariActiveUserData,
    setCariFormActivePositionData,
    setCariFormActiveApplicationData,
    setCariUrlParamsData
} from "../../../redux/actions/indexActions";

//redux mapper
const mapDispatchToProps = dispatch => {
    return {
        setCariActiveVerifiedLoginUserData: (user_data) => {
            dispatch(setCariActiveVerifiedLoginUserData(user_data))
        },
        setCariActiveUserData: (user_data) => {
            dispatch(setCariActiveUserData(user_data))
        },
        setCariFormActivePositionData: (position_data) => {
            dispatch(setCariFormActivePositionData(position_data))
        },
        setCariFormActiveApplicationData: (application_data) => {
            dispatch(setCariFormActiveApplicationData(application_data))
        },
        setCariUrlParamsData: (url_params_data) => {
            dispatch(setCariUrlParamsData(url_params_data))
        }
    };
};
const mapStateToProps = state => {
    return {    
        activeUserData: state.cariReducer.activeUserData,
        activeVerifiedLoginUserData: state.cariReducer.activeVerifiedLoginUserData,
        activePositionData: state.cariReducer.activePositionData,
        activeUrlParamData: state.cariReducer.activeUrlParamData
    };
};

class CariMainRouter extends Component {

    state = {
        siteTitle: "Academic Recruitment",
    }

    constructor(props) {
        super(props);

        //helper functions
        this.checkIfUserDataExists = this.checkIfUserDataExists.bind(this);
        this.checkIfValidEmailRegex = this.checkIfValidEmailRegex.bind(this);
        this.checkIfUrlParamsExist = this.checkIfUrlParamsExist.bind(this);

        if (process.env.REACT_APP_ENV === 'development') {
            this.props.setCariActiveVerifiedLoginUserData({ "email": process.env.REACT_APP_EMAIL, "token": process.env.REACT_APP_TOKEN });
            this.props.setCariActiveUserData({ "first_name": process.env.REACT_APP_USER_FIRSTNAME, "last_name": process.env.REACT_APP_USER_LASTNAME});
        }
    }

    checkIfValidEmailRegex(test_str) {
        var pattern = new RegExp(emailRegex);
        return pattern.test(test_str);
    }


    //returns boolean if user data from redux store exists and is valid: valid email, valid token, first name and last name is not empty
    checkIfUserDataExists() {
        if (!isEmpty(this.props.activeUserData)
            && !isEmpty(this.props.activeVerifiedLoginUserData)
            && !isEmpty(this.props.activeVerifiedLoginUserData.email)
            && this.checkIfValidEmailRegex(this.props.activeVerifiedLoginUserData.email)
            && !isEmpty(this.props.activeVerifiedLoginUserData.token)
            && !isEmpty(this.props.activeUserData.first_name)
            && !isEmpty(this.props.activeUserData.last_name)
        ) {
            return true;
        }
        else {
            return false;
        }
    }

    // Check if url params are set.
    // If they are it means an external link is being used (probably from https://beedie.sfu.ca/about/work-for-us) and we need to route directly to the application.
    checkIfUrlParamsExist() {
        var url = window.location.href;
        var urlParams = new URLSearchParams(window.location.search);
        var positionId = urlParams.get('position_id');
        var positionTitle = urlParams.get('position_title');

        if (url.includes('app_form/consent') && positionId != null && positionTitle != null) {
            this.props.setCariFormActivePositionData({ "position_id": positionId, "position_title": positionTitle });
            this.props.setCariUrlParamsData({ "url_params_set": true });
        }
    }

    render() {
        this.checkIfUrlParamsExist();
        return (
            <div>

                <CariModals/>

                <Switch>
                    {/* renders cari external page or logged in pages */}
                    {!(this.checkIfUserDataExists()) ?
                        <Route
                            path={cari_home_pg_url}
                            render={() =>
                                <CariMainPg
                                    siteTitle={this.state.siteTitle}
                                />
                            }
                        />
                        :
                        <Route
                            path={cari_home_pg_url}
                            render={() =>
                                <CariMainPgLoggedIn
                                    siteTitle={this.state.siteTitle}
                                />
                            }
                        />
                    }
                    <Redirect
                        from='*'
                        to={cari_home_pg_url}
                    />
                </Switch>
            </div>
        );
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(CariMainRouter);